import styled, { css } from 'styled-components';

export const TrayShell = styled.div<{ width: number; side: 'left' | 'right' }>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: ${({ width }) => width}px;
  max-width: 50vw;
  height: 100%;
  background: #fff;
  ${({ side }) =>
    side === 'left'
      ? css`border-right: 1px solid ${(props) => props.theme.colorStyled.ColorBorderInput};`
      : css`border-left: 1px solid ${(props) => props.theme.colorStyled.ColorBorderInput};`}
  @media (max-width: 768px) {
    display: none;
  }
`;

export const TrayHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5em 0.75em;
  border-bottom: 1px solid ${(props) => props.theme.colorStyled.ColorBorderInput};
  flex-shrink: 0;
`;

export const TrayTitle = styled.span`
  font-size: ${(props) => props.theme.fontSize.PrimaryFontSize};
  font-weight: 600;
  text-transform: uppercase;
  color: ${(props) => props.theme.colorStyled.ColorDarkGrey};
`;

export const TrayCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  color: ${(props) => props.theme.colorStyled.ColorDarkGrey};
  font-size: 1rem;
  line-height: 1;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
    outline-offset: 2px;
  }
  &:hover {
    background: ${(props) => props.theme.colorStyled.ColorBgSilver};
  }
`;

export const TrayPanel = styled.section`
  flex: 1;
  overflow: hidden;
  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
    outline-offset: -2px;
  }
`;

export const TrayResizeHandle = styled.div<{ side: 'left' | 'right' }>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 12px;
  cursor: ew-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ side }) => (side === 'left' ? css`right: -6px;` : css`left: -6px;`)}
  z-index: 2;
  &::after {
    content: '';
    width: 4px;
    height: 48px;
    border-radius: 2px;
    background: ${(props) => props.theme.colorStyled.ColorBorderInput};
    transition: background 150ms ease;
  }
  &:hover::after,
  &:focus-visible::after {
    background: ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
  }
  &:focus-visible {
    outline: none;
  }
`;

export const TrayEdgeHandle = styled.div<{ side: 'left' | 'right' }>`
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const TrayEdgeButton = styled.button<{ side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ side }) => (side === 'left' ? css`left: 0;` : css`right: 0;`)}
  background: ${(props) => props.theme.colorStyled.ColorOrange};
  border: 1px solid ${(props) => props.theme.colorStyled.ColorOrange};
  ${({ side }) =>
    side === 'left'
      ? css`
          border-left: none;
          border-radius: 0 8px 8px 0;
        `
      : css`
          border-right: none;
          border-radius: 8px 0 0 8px;
        `}
  padding: 10px 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 44px;
  z-index: 2;
  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colorStyled.ColorPrimaryBlue};
    outline-offset: 2px;
  }
  &:hover {
    filter: brightness(1.1);
  }
`;

export const TrayEdgeLabel = styled.span`
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colorStyled.ColorPrimary};
`;

export const TrayEdgeChevron = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colorStyled.ColorPrimary};
`;

export const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2em 2em 3.5em;
  font-size: ${(props) => props.theme.fontSize.PrimaryFontSize};
  @media (max-width: 768px) {
    padding: 1em 1em 3.5em;
  }
`;
